export default () => {
  class Pagination extends HTMLElement {
    constructor() {
      super();

      this.currentPage = 1;
      this.productsPerPage = this.getAttribute("productsPerPage");
      this.collectionHandle = this.getAttribute("collectionHandle");
    }

    connectedCallback() {
      this.totalProductsElement = document.getElementById('products_count');
      this.loadMoreBtn = document.getElementById('load_more_btn');
      this.progressBar = document.getElementById('bar');
      this.productGrid = document.querySelector('#product-grid .product-grid__wrapper');
      this.totalPageNumber = this.loadMoreBtn.getAttribute('data-total-page');

      if (!this.totalProductsElement || !this.loadMoreBtn || !this.progressBar || !this.productGrid) return;

      this.totalProducts = parseInt(this.totalProductsElement.value, 10);
      this.action();
    }

    action() {
      this.updateProgress();
      this.loadMoreBtn.addEventListener('click', () => this.loadMoreProducts());
    }

    hideButton(){
      // eslint-disable-next-line
      if(this.currentPage == this.totalPageNumber){
        this.loadMoreBtn.classList.add('hidden');
      } else {
        this.loadMoreBtn.classList.remove('hidden');
      }
    }

    loadMoreProducts() {
      this.currentPage += 1;
      this.hideButton();
      this.fetchProducts(this.currentPage);
    }

    fetchProducts(page) {
      const sort = new URLSearchParams(Shopify.queryParams).toString()
      fetch(`/collections/${this.collectionHandle}?view=ajax&page=${page}&${sort}`)
        .then(response => response.text())
        .then(data => {
          const parser = new DOMParser();
          const newProducts = parser.parseFromString(data, 'text/html').querySelector('#product-grid .product-grid__wrapper');
          if (newProducts) {
            this.productGrid.append(...newProducts.children);
            this.updateProgress();
            document.dispatchEvent(new CustomEvent('swym:collections-loaded'))
          } else {
            // eslint-disable-next-line no-console
            console.error('New products element not found in fetched data');
          }
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error('Error:', error)
        });
    }

    updateProgress() {
      const visibleProducts = this.productGrid.querySelectorAll('.product-grid__item').length;
      const progressPercentage = (visibleProducts / this.totalProducts) * 100;
      this.progressBar.setAttribute('aria-valuemax', this.totalProducts)
      this.progressBar.setAttribute('aria-valuenow', progressPercentage)
      this.progressBar.style.width = `${progressPercentage}%`;
    }
  }

  const init = () => {
    if (!customElements.get("fetch-pagination")) {
      customElements.define("fetch-pagination", Pagination);
    }
  };

  init();
};
